import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons/faCircleExclamation";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FRONTEND_ACTION } from "components/Common/MultiFactorAuthentication";
import { ACCOUNT_PATH, IDENTITY_PATH, SECURITY_PATH } from "helperFunctions/paths";
import { FormattedMessage, useIntl } from "react-intl";
export const securityZoneAction = sessionStorage.getItem(FRONTEND_ACTION);
export function SecurityZoneInfo() {
    const intl = useIntl();
    const toSecurity = (_jsx("a", { href: SECURITY_PATH, "aria-label": "return to security page", onClick: () => sessionStorage.clear(), children: _jsx(FormattedMessage, { id: "common.security", description: "security zone security link", defaultMessage: "Security" }) }));
    const toAccount = (_jsx("a", { href: ACCOUNT_PATH, "aria-label": "return to account page", onClick: () => sessionStorage.clear(), children: _jsx(FormattedMessage, { id: "common.account", description: "security zone account link", defaultMessage: "Account" }) }));
    const toIdentity = (_jsx("a", { href: IDENTITY_PATH, "aria-label": "return to identity page", onClick: () => sessionStorage.clear(), children: _jsx(FormattedMessage, { id: "common.identity", description: "security zone identity link", defaultMessage: "Identity" }) }));
    const actionMap = {
        changeSecurityPreferencesAuthn: {
            action: intl.formatMessage({
                id: "securityZoneInfo.changeSecurity",
                defaultMessage: "change security key preferences",
            }),
            redirectPath: toSecurity,
        },
        addSecurityKeyAuthn: {
            action: intl.formatMessage({
                id: "securityZoneInfo.add",
                defaultMessage: "add security key",
            }),
            redirectPath: toSecurity,
        },
        removeSecurityKeyAuthn: {
            action: intl.formatMessage({
                id: "securityZoneInfo.removeSecurity",
                defaultMessage: "remove security key",
            }),
            redirectPath: toSecurity,
        },
        verifyCredential: {
            action: intl.formatMessage({
                id: "securityZoneInfo.verify",
                defaultMessage: "verify security key",
            }),
            redirectPath: toSecurity,
        },
        terminateAccountAuthn: {
            action: intl.formatMessage({
                id: "securityZoneInfo.delete",
                defaultMessage: "delete account",
            }),
            redirectPath: toAccount,
        },
        changepwAuthn: {
            action: intl.formatMessage({
                id: "securityZoneInfo.change",
                defaultMessage: "change password",
            }),
            redirectPath: toAccount,
        },
        removeIdentity: {
            action: intl.formatMessage({
                id: "securityZoneInfo.remove",
                defaultMessage: "remove identity",
            }),
            redirectPath: toIdentity,
        },
    };
    const current = securityZoneAction ? actionMap[securityZoneAction] : undefined;
    return (_jsx(_Fragment, { children: securityZoneAction && (_jsxs("div", { className: "status-box", children: [_jsx("div", { className: "checkbox-wrapper", children: _jsx(FontAwesomeIcon, { icon: faCircleExclamation, className: "disabled" }) }), _jsxs("div", { className: "text-wrapper", children: [_jsx("h3", { children: _jsx(FormattedMessage, { id: "securityZoneInfo.heading", defaultMessage: `Authenticate to continue`, description: "security zone redirect info" }) }), _jsx("p", { children: _jsx(FormattedMessage, { id: "securityZoneInfo.afterward", defaultMessage: `Afterward, you will be redirected to the page to {action}.`, description: "security zone redirect info", values: {
                                    action: current === null || current === void 0 ? void 0 : current.action,
                                } }) }), _jsx("span", { className: "top-divider help-text", children: _jsx(FormattedMessage, { id: "securityZoneInfo.info", defaultMessage: `If you wish to {strong} this process without affecting a change you can return straight to {page} page.`, description: "security zone cancel info", values: {
                                    page: current === null || current === void 0 ? void 0 : current.redirectPath,
                                    strong: (_jsx("strong", { children: _jsx(FormattedMessage, { id: "securityZoneInfo.mfa", description: "mfa cancel - strong", defaultMessage: `cancel` }) })),
                                } }) })] })] })) }));
}
